var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-drawer',{attrs:{"maskClosable":false,"width":"60%","label-col":4,"wrapper-col":14,"visible":_vm.open,"destroyOnClose":true},on:{"close":_vm.onClose}},[_c('a-divider',{attrs:{"orientation":"left"}},[_c('b',[_vm._v(_vm._s(_vm.formTitle))])]),_c('Parameter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }